import { applicationConstants } from './application.constants'

const applicationState = {
  loading: false,
  showSideMenu: true,
  showSideMenuIntranet: false,
  showSideMenuAdmin: false,
}

export function application(state = applicationState, action) {
  switch (action.type) {
    case applicationConstants.TOGGLE_SIDEBAR_ON:
      return {
        ...state,
        showSideMenu: true,
        showSideMenuIntranet: false,
        showSideMenuAdmin: false,
      }
    case applicationConstants.TOGGLE_SIDEBAR_OFF:
      return {
        ...state,
        showSideMenu: false,
        showSideMenuIntranet: false,
        showSideMenuAdmin: false,
      }
    case applicationConstants.LOADING_ON:
      return {
        ...state,
        loading: true,
      }
    case applicationConstants.LOADING_OFF:
      return {
        ...state,
        loading: false,
      }
    case applicationConstants.TOGGLE_SIDEBAR_INTRANET_ON:
      return {
        ...state,
        showSideMenu: false,
        showSideMenuAdmin: false,
        showSideMenuIntranet: true,
      }
    case applicationConstants.TOGGLE_SIDEBAR_ADMIN_ON:
      return {
        ...state,
        showSideMenu: false,
        showSideMenuIntranet: false,
        showSideMenuAdmin: true,
      }
    default:
      return state
  }
}
